"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _withStyles = _interopRequireDefault(require("../withStyles"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * A component that allows a small tooltip to appear when hovered or clicked.
 */
var Tooltip =
/*#__PURE__*/
function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip(props) {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tooltip).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "toggleTooltip", function () {
      return _this.setState(function (state) {
        return {
          open: !state.open
        };
      });
    });

    _this.state = {
      open: false
    };
    return _this;
  }

  _createClass(Tooltip, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          clickEnabled = _this$props.clickEnabled,
          children = _this$props.children,
          focusDisable = _this$props.focusDisable;
      var open = this.state.open;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(classes.root, open && classes.active, className),
        onMouseEnter: function onMouseEnter() {
          return !clickEnabled ? _this2.toggleTooltip() : null;
        },
        onMouseLeave: function onMouseLeave() {
          return !clickEnabled ? _this2.toggleTooltip() : null;
        },
        onFocus: function onFocus() {
          return !clickEnabled && !focusDisable ? _this2.toggleTooltip() : null;
        },
        onClick: function onClick() {
          return clickEnabled ? _this2.toggleTooltip() : null;
        },
        onBlur: function onBlur() {
          return open ? _this2.toggleTooltip() : null;
        },
        role: "tooltip",
        "aria-hidden": !open
      }, children);
    }
  }]);

  return Tooltip;
}(_react.Component);

_defineProperty(Tooltip, "defaultProps", {
  position: "top"
});

var calculateRotation = function calculateRotation(props) {
  if (props.position === "top") {
    return "rotate(180deg)";
  } else if (props.position === "right") {
    return "rotate(-90deg)";
  } else if (props.position === "left") {
    return "rotate(90deg)";
  }
};

var styles = function styles(theme) {
  return {
    root: {
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      overflow: "visible",
      "&:before": {
        content: "''",
        display: "none",
        position: "absolute",
        top: function top(props) {
          return props.position === "bottom" ? "calc(100% + 4px)" : null;
        },
        left: function left(props) {
          return props.position === "right" ? "100%" : null;
        },
        right: function right(props) {
          return props.position === "left" ? "100%" : null;
        },
        bottom: function bottom(props) {
          return props.position === "top" ? "calc(100% + 4px)" : null;
        },
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "0 10px 10px 10px",
        borderColor: "transparent transparent rgba(0,0,0,0.95) transparent",
        transform: function transform(props) {
          return calculateRotation(props);
        }
      },
      "&:after": {
        content: function content(props) {
          return "\"".concat(props.text, "\"");
        },
        display: "none",
        position: "absolute",
        flexFlow: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "auto",
        padding: "8px 10px",
        backgroundColor: "rgba(0,0,0,0.95)",
        borderRadius: "3px",
        fontSize: "14px",
        fontWeight: "normal",
        color: theme.colors["white"],
        whiteSpace: "nowrap",
        zIndex: theme.zIndex["tooltip"],
        top: function top(props) {
          return props.position === "bottom" ? "calc(100% + 10px)" : null;
        },
        left: function left(props) {
          return props.position === "right" ? "calc(100% + 10px)" : null;
        },
        right: function right(props) {
          return props.position === "left" ? "calc(100% + 10px)" : null;
        },
        bottom: function bottom(props) {
          return props.position === "top" ? "calc(100% + 10px)" : null;
        }
      }
    },
    active: {
      "&:before": {
        display: "block"
      },
      "&:after": {
        display: "flex"
      }
    }
  };
};

var _default = (0, _withStyles["default"])(styles, {
  name: "EuiTooltip"
})(Tooltip);

exports["default"] = _default;